import Icon from 'veui/components/Icon'

Icon.register({
  'file-txt': {
    paths: [
      {
        fill: '#989994',
        d: 'M27.68 9.81l-6.66-8a1.34 1.34 0 00-1.03-.48H6a2 2 0 00-2 2v25.34c0 1.1.9 2 2 2h20a2 2 0 002-2v-18c0-.05-.06-.56-.3-.86z'
      },
      {
        fill: '#c1c2bf',
        d: 'M21.02 1.81a1.34 1.34 0 00-1.03-.48v7.34c0 1.1.9 2 2 2h6c0-.05-.06-.56-.3-.86z'
      },
      {
        fill: '#fff',
        d: 'M21.05 13.3h-10.1a.63.63 0 00-.63.64v.92c0 .35.28.63.63.63h3.6c.17 0 .31.14.31.32v9.5c0 .35.28.63.63.63h1.02c.35 0 .63-.28.63-.63v-9.5c0-.18.14-.32.32-.32h3.6c.34 0 .62-.28.62-.63v-.92a.63.63 0 00-.63-.63z'
      }
    ],
    width: '32',
    height: '32'
  }
})
